import React from 'react';
import { 
  Container, 
  Title, 
  ServicesGrid, 
  ServiceCard 
} from './style';
import { 
  FaRobot, 
  FaProjectDiagram, 
  FaBolt, 
  FaCogs 
} from 'react-icons/fa';
import { motion } from 'framer-motion';

const services = [
  {
    heading: 'Artificial Intelligence (AI Solutions)',
    icon: <FaRobot style={{ marginRight: 10 }} />,
    items: ['Predictive applications', 'Computer vision', 'Chatbots'],
  },
  {
    heading: 'Enterprise Resource Planning (ERP)',
    icon: <FaProjectDiagram style={{ marginRight: 10 }} />,
    items: [
      'Process integration',
      'Financial management',
      'Resource management',
      'Business Intelligence (BI), smart decision-making',
    ],
  },
  {
    heading: 'Smart Energy Solutions',
    icon: <FaBolt style={{ marginRight: 10 }} />,
    items: ['Monitoring and control systems', 'Digital energy consulting'],
  },
  {
    heading: 'Customized Digital Transformation',
    icon: <FaCogs style={{ marginRight: 10 }} />,
    items: [
      'Strategies and development of tailored technological solutions',
      'Cloud migration',
      'System integration and automation',
      'Legacy system modernization',
    ],
  },
];

const OurServices = () => (
  <Container>
    <Title>Our Services</Title>
    <ServicesGrid>
      {services.map((section, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
        >
          <ServiceCard>
            <h3>{section.icon} {section.heading}</h3>
            <ul>
              {section.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </ServiceCard>
        </motion.div>
      ))}
    </ServicesGrid>
  </Container>
);

export default OurServices;
